import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MaterialModule } from 'src/app/material.module';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { HotelCardLoaderComponent } from './hotel/hotel-card-loader/hotel-card-loader.component';
import { HotelListLoaderComponent } from './hotel/hotel-list-loader/hotel-list-loader.component';
import { HotelDetailLoaderComponent } from './hotel/hotel-detail-loader/hotel-detail-loader.component';
import { HotelBookingLoaderComponent } from './hotel/hotel-booking-loader/hotel-booking-loader.component';
import { HotelSummaryLoaderComponent } from './hotel/hotel-booking-loader/hotel-summary-loader/hotel-summary-loader.component';
import { FlightResultLoaderComponent } from './flight/flight-result-loader/flight-result-loader.component';
import { FlightRoundWayLoaderComponent } from './flight/flight-round-way-loader/flight-round-way-loader.component';
import { FlightBookingLoaderComponent } from './flight/flight-booking-loader/flight-booking-loader.component';
import { FlightResultWayComponent } from './flight/flight-result-way/flight-result-way.component';
import { StaticPageLoaderComponent } from './static-page/static-page-loader/static-page-loader.component';
import { StaticHeaderLoaderComponent } from './static-page/static-header-loader/static-header-loader.component';



@NgModule({
  declarations: [
    HotelCardLoaderComponent,
    HotelListLoaderComponent,
    HotelDetailLoaderComponent,
    HotelBookingLoaderComponent,
    HotelSummaryLoaderComponent,
    FlightResultLoaderComponent,
    FlightRoundWayLoaderComponent,
    FlightBookingLoaderComponent,
    FlightResultWayComponent,
    StaticPageLoaderComponent,
    StaticHeaderLoaderComponent
  ],
  imports: [
    CommonModule, CarouselModule, MaterialModule,NgxStarRatingModule
  ],
  exports: [
    HotelCardLoaderComponent,
    HotelListLoaderComponent,
    HotelDetailLoaderComponent,
    HotelBookingLoaderComponent,
    HotelSummaryLoaderComponent,
    FlightResultLoaderComponent,
    FlightRoundWayLoaderComponent,
    FlightBookingLoaderComponent,
    FlightResultWayComponent,
    StaticPageLoaderComponent,
    StaticHeaderLoaderComponent
  ]
})
export class LoaderModule { }
